module.exports = __webpack_public_path__ + "img/sen_SNB.0420035a.svg";